import { SpecializationsSelector } from "./SpecializationsSelector";

export default SpecializationsSelector;
